export default [
  'body-caption',
  'body-caption-small',

  'body-text-small',
  'body-text-big',
  'body-text',

  'body-h1',
  'body-h2',
  'body-h3',
  'body-h5',

  'body-heading-1',
  'body-heading-2',
  'body-heading-3',
  'body-heading-4',
  'body-heading-5',

  'body-heading-1-2',
]
